import { render, staticRenderFns } from "./Lenta.vue?vue&type=template&id=43064530&scoped=true"
import script from "./Lenta.vue?vue&type=script&lang=js"
export * from "./Lenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43064530",
  null
  
)

export default component.exports